"use strict";

exports.__esModule = true;
exports.AdvancedTimelineSelector = AdvancedTimelineSelector;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _AdvancedTimelineContext = require("./AdvancedTimelineContext");
var _Selector = require("../../Core/Selector");
var _SelectorOption = require("./SelectorOption");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PlaceHolder = function PlaceHolder() {
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AdvancedTimelineFields.TimelineSelector.label",
    defaultMessage: "Timeline"
  });
};
function AdvancedTimelineSelector(props) {
  var elementEditor = props.elementEditor,
    path = props.path,
    element = props.element;
  var timelines = _react["default"].useContext(_AdvancedTimelineContext.AdvancedTimelineContext);
  var selectedTimeline = timelines.filter(function (timeline) {
    return timeline.type === element.props.timeline;
  });
  var _onSelect = function onSelect(timeline) {
    elementEditor.setProps(path, Object.assign({}, element.props, {
      timeline: timeline,
      dimensions: [],
      labels: [],
      colorSource: ""
    }));
  };
  (0, _react.useEffect)(function () {
    if (!selectedTimeline.length && timelines && timelines.length) {
      _onSelect(timelines[0].type);
    }
  }, [timelines]);
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(PlaceHolder, null)
  }, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    items: timelines,
    getKey: function getKey(timeline) {
      return timeline.type;
    },
    selected: selectedTimeline,
    onSelect: function onSelect(selectedTimelines) {
      return selectedTimelines.length ? _onSelect(selectedTimelines[0].type) : null;
    },
    renderItemText: function renderItemText(timeline) {
      return /*#__PURE__*/_react["default"].createElement(_SelectorOption.SelectorOption, {
        value: timeline.label,
        parentComponent: "AdvancedTimelineSelector"
      });
    },
    placeholder: /*#__PURE__*/_react["default"].createElement(PlaceHolder, null),
    width: 275
  }));
}